import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { api } from "@/lib/api";
import { FileText, Receipt, Users, Building2, Boxes, Plus, BarChart3, Sparkles, BookOpenCheck } from "lucide-react";

export default function CommandPalette({ open, onOpenChange }) {
    const [q, setQ] = useState("");
    const [results, setResults] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (q.length < 2) { setResults([]); return; }
        const t = setTimeout(() => {
            api.get(`/search`, { params: { q } }).then(({ data }) => setResults(data.results || []));
        }, 180);
        return () => clearTimeout(t);
    }, [q]);

    const go = (path) => { onOpenChange(false); navigate(path); };

    const iconFor = (t) => ({
        customer: Users, vendor: Building2, invoice: Receipt, bill: FileText, item: Boxes,
    }[t] || FileText);

    const linkFor = (r) => {
        if (r.type === "customer") return `/sales/customers`;
        if (r.type === "vendor") return `/purchases/vendors`;
        if (r.type === "invoice") return `/sales/invoices/${r.id}`;
        if (r.type === "bill") return `/purchases/bills`;
        if (r.type === "item") return `/inventory/items`;
        return "/";
    };

    return (
        <CommandDialog open={open} onOpenChange={onOpenChange}>
            <CommandInput placeholder="Search anything or jump to a screen…" value={q} onValueChange={setQ} data-testid="command-input" />
            <CommandList>
                <CommandEmpty>No results.</CommandEmpty>
                {results.length > 0 && (
                    <CommandGroup heading="Search results">
                        {results.map((r) => {
                            const Icon = iconFor(r.type);
                            return (
                                <CommandItem key={`${r.type}-${r.id}`} onSelect={() => go(linkFor(r))} data-testid={`cmd-result-${r.id}`}>
                                    <Icon className="w-4 h-4 mr-2 text-muted-foreground" strokeWidth={1.5} />
                                    <span className="flex-1">{r.title}</span>
                                    <span className="text-[11px] text-muted-foreground">{r.subtitle}</span>
                                </CommandItem>
                            );
                        })}
                    </CommandGroup>
                )}
                <CommandGroup heading="Quick actions">
                    <CommandItem onSelect={() => go("/sales/invoices/new")}><Plus className="w-4 h-4 mr-2" />New Invoice</CommandItem>
                    <CommandItem onSelect={() => go("/sales/customers")}><Plus className="w-4 h-4 mr-2" />New Customer</CommandItem>
                    <CommandItem onSelect={() => go("/purchases/bills")}><Plus className="w-4 h-4 mr-2" />New Bill</CommandItem>
                    <CommandItem onSelect={() => go("/accounting/journals")}><Plus className="w-4 h-4 mr-2" />New Journal Entry</CommandItem>
                </CommandGroup>
                <CommandGroup heading="Jump to">
                    <CommandItem onSelect={() => go("/")}><BarChart3 className="w-4 h-4 mr-2" />Dashboard</CommandItem>
                    <CommandItem onSelect={() => go("/copilot")}><Sparkles className="w-4 h-4 mr-2" />AI Copilot</CommandItem>
                    <CommandItem onSelect={() => go("/reports")}><BarChart3 className="w-4 h-4 mr-2" />Reports</CommandItem>
                    <CommandItem onSelect={() => go("/accounting/coa")}><BookOpenCheck className="w-4 h-4 mr-2" />Chart of Accounts</CommandItem>
                </CommandGroup>
            </CommandList>
        </CommandDialog>
    );
}
